import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import * as actions from '../Actions.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react';
import React from 'react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react';

export class FormDetailEntidadesBeneficiadas extends Component {
  static propTypes = {
    pageEntidadesBeneficiadas: PropTypes.object.isRequired,
    findEntidadesBeneficiadas: PropTypes.func.isRequired,
    idEmenda: PropTypes.number.isRequired
  };

  componentDidMount() {
    this.searchWithPage(
      this.props.pageEntidadesBeneficiadas.set('number', 0).set('size', 20)
    );
  }

  searchWithPage = page => {
    const { findEntidadesBeneficiadas, idEmenda } = this.props;
    findEntidadesBeneficiadas(idEmenda, page);
  };

  renderRow = (entidadesbeneficiadas, index) => {
    return (
      <tr key={index}>
        <td>{entidadesbeneficiadas.get('descricao')}</td>
      </tr>
    );
  };

  render() {
    const { pageEntidadesBeneficiadas } = this.props;
    const content = pageEntidadesBeneficiadas.get('content', List());

    return (
      <div>
        {content.size > 0 ? (
          <table className="panel-table striped fancy">
            <TableHeader empty={content.isEmpty()}>
              <tr>
                <th>Nome</th>
              </tr>
            </TableHeader>
            <tbody>{content.map(this.renderRow)}</tbody>
          </table>
        ) : (
          <div className="empty-state">Nenhuma entidade encontrada.</div>
        )}
        <SearchPagination
          page={pageEntidadesBeneficiadas}
          searchWithPage={this.searchWithPage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageEntidadesBeneficiadas: state.emendaContabilidade.get(
      'entidadesbeneficiadas'
    )
  };
}

const allActions = {
  findEntidadesBeneficiadas: actions.findEntidadesBeneficiadas
};

export default connect(
  mapStateToProps,
  allActions
)(FormDetailEntidadesBeneficiadas);
